import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

import {
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
    GET_TEMPLATE_DETAILS_SUCCESS,
    GET_TEMPLATE_DETAILS_FAILURE,
    SET_PRODUCT_TEMPLATE_REFINE_DATA,
    UPDATE_PRODUCT_TEMPLATE_SUCCESS,
    UPDATE_PRODUCT_TEMPLATE_FAILURE,
    CREATE_PRODUCT_TEMPLATE_SUCCESS,
    CREATE_PRODUCT_TEMPLATE_FAILURE,
    SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
    GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE,
    GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS,
} from '../actions/actionTypes';
import {
    getDataForconsignmentAddTemplateDataService,
    getDetailedconsignmentAddProductTemplatesDataService,
    getconsignmentAddTemplateDetailsDataService,
    updateconsignmentAddProductTemplateDataService,
} from '../../services';
import { getDropdownValues } from '../actions';

export function* getDetailedconsignmentAddProductTemplates(action) {
    const resourceType = 'ORDER_TEMPLATE_B';

    try {
        const result = yield getDetailedconsignmentAddProductTemplatesDataService(
            convertObjectToQueryParams({
                ...action.payload,
                resourceType: resourceType,
                templateType: action.payload.orderType,
            })
        );
        yield put({
            type: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
            payload: result.templateList || [],
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            pagination: {
                pageNum: result.pageNo,
                pageLimit: result.pageSize,
            },
            totalNoOfResults: result.totalNoOfResults,
        });
        yield put({
            type: SET_PRODUCT_TEMPLATE_REFINE_DATA,
            payload: result.templateRefineData || {},
        });
        yield put({
            type: SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
            payload: result.templateSubCategoryList || [],
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/productTemplates/templateslist`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* getconsignmentAddTemplateDetails(action) {
    try {
        const result = yield getconsignmentAddTemplateDetailsDataService(
            action.payload
        );
        yield put({
            type: GET_TEMPLATE_DETAILS_SUCCESS,
            payload: result || {},
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/productTemplates/templatesdetails/${action.payload}`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_TEMPLATE_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* createconsignmentAddProductTemplate(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`;
    let result;
    let insideCatch = false;
    let responseData;
    try {
        result = yield axios
            .post(url, { ...action.payload })
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    // Request made and server responded
                    insideCatch = true;
                    responseData = error.response.data;
                    logUiErrorToBackend('error response', error.response);
                } else if (error.request) {
                    // The request was made but no response was received
                    logUiErrorToBackend('error request', error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    logUiErrorToBackend('error message', error.message);
                }
            });
        // yield createconsignmentAddProductTemplateDataService({...action.payload});
        if (insideCatch) {
            yield put({
                type: CREATE_PRODUCT_TEMPLATE_FAILURE,
                statusCode: responseData.statusCode,
                statusMessage: responseData.statusDescription,
            });
            insideCatch = false;
        } else {
            yield put({
                type: CREATE_PRODUCT_TEMPLATE_SUCCESS,
                payload: result || {},
            });
        }
    } catch (e) {
        // eslint-disable-next-line camelcase
        const error_log = JSON.parse(JSON.stringify(e));
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`,
            requestPayload: action.payload
        });
        yield put({
            type: CREATE_PRODUCT_TEMPLATE_FAILURE,
            statusCode: '422',
            statusMessage: errorHandler('422'),
        });
    }
}

export function* updateconsignmentAddProductTemplate(action) {
    try {
        const result = yield updateconsignmentAddProductTemplateDataService({
            ...action.payload,
        });
        yield put({
            type: UPDATE_PRODUCT_TEMPLATE_SUCCESS,
            payload: result || {},
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`,
            requestPayload: action.payload
        });
        yield put({
            type: UPDATE_PRODUCT_TEMPLATE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* getDataForconsignmentAddTemplate(action) {
    try {
        const result = yield getDataForconsignmentAddTemplateDataService(
            action.payload.MyCASERef,
            action.payload.orderType
        );
        yield put({
            type: GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS,
            payload: result || {},
        });
        yield getDropdownValues({
            dropDownName: 'territories',
            value: result && result.districtUID,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/productTemplates/templatesdetails/${action.payload.MyCASERef}?isMyCASERef=true&orderType=${action.payload.orderType}`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
